module.exports = __webpack_public_path__ + "static/media/banner.7a1e7377.png";